import '/assets/styles/sections/casual-events.scss';
import { useEffect, useMemo, useState } from 'react';
import { useInView } from 'react-intersection-observer'
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Functions
import formatDate from '@wearetla/tla-essentials-tools/functions/format-date';
import createEventBtnParams from '/functions/create-event-btn-params';

// Partials
import Icon from '@wearetla/tla-essentials-tools/partials/icon';
import Link from '@wearetla/tla-essentials-tools/partials/link';
import Slider from '/views/partials/slider';
import Btn from '/views/partials/btn';
import Placeholder from '/views/partials/placeholder';

// Services
import siteServices from '/services/site';

// Context
import { useBreakpoints } from '@wearetla/tla-essentials-tools/utilities/breakpoints';
import { useGlobalEvents } from '@wearetla/tla-essentials-tools/utilities/global-events';
// import { useLocations } from '/utilities/locations';

const SHOWCASE_KEY = 'ANKARA_WEEKLY';

const getCasualEvents = (location) => {
	return siteServices.getShowcase(SHOWCASE_KEY, { location });
}

const CasualEvents = ({ id }) => {
	// const { selectedLocation } = useLocations();
	const { desktop } = useBreakpoints();
	const [data, setData] = useState(null);

	useEffect(() => {
		setData(null);
		getCasualEvents('Ankara').then((setData)).catch(() => {
			setData(undefined);
		})
	}, [])

	const events = useMemo(() => (data?.events ? data.events.map((event) => {
		const date = new Date(event.calendar.full_date);

		const day = formatDate(date, 'EEEE', { parsed: true });
		const time = formatDate(date, 'HH:mm', { parsed: true });

		return {
			...event,
			day,
			time,
		}
	}) : [false, false, false, false, false]), [data]);

	if(data === undefined) {
		return null;
	}

	return (
		<section className="section casualevents">
			<div className="casualevents-wrap wrapper narrow">
				{data ?
					<h2 className="casualevents-title">
						{data.icon &&
							<Icon name={data.icon} className="title-icon" />
						}
						<span className="title-text">{data.title}</span>
					</h2>
					:
					<div className="casualevents-title">
						<Placeholder className="title-icon" />
						<Placeholder className="title-text" />
					</div>
				}

				<Slider
					className="casualevents-slider"
					id={`${id ?? 'casualevents'}-slider`}
					navigation={desktop}
					key={`casualevents-slider-${data?.events ? 'has-data' : 'no-data'}`}
					pagination={!desktop}
					params={{
						slidesPerView: desktop ? 5 : 2,
					}}>
					{events.map((event, nth) => (
						<CasualEventBox
							event={event}
							listName={data?.title}
							key={event?.id ?? nth} />
					))}
				</Slider>

				{desktop &&
					<Icon name="party" className="casualevents-icon" />
				}
			</div>
		</section>
	)
}

const CasualEventBox = ({ event, listName }) => {
	const { desktop } = useBreakpoints();
	const { triggerEvent } = useGlobalEvents();
	const [observerRef, inView] = useInView({
		threshold: 0,
		rootMargin: '5%',
		triggerOnce: true,
		disabled: !listName,
	});

	useEffect(() => {
		if(inView && event) {
			triggerEvent('listItemView', {
				listId: SHOWCASE_KEY,
				listName: listName,
				item: event,
			})
		}
	}, [inView, event, listName])

	return (event ? 
		(
			<div ref={observerRef}>
				<Link
					href="eventDetail"
					params={{id: event.id, slug: event.slug }}
					className="casualevents-event">
					<div className="event-datetime">
						<span className="datetime-day">{event.day}</span>
						<span className="datetime-time">{event.time}</span>
					</div>
					<strong className="event-title">{event.title}</strong>
					{event.calendar &&
						<Btn
							{...createEventBtnParams(event, event.calendar)}
							className={classNames('event-buybtn', 'red', { 'text-big': desktop, small: !desktop })}>
							BİLET AL
						</Btn>
					}
					<Btn
						hollowLink
						href="eventDetail"
						params={{id: event.id, slug: event.slug }}
						className={classNames('event-detailsbtn', 'white', 'nude')}>
						Detayları Gör
					</Btn>
				</Link>
			</div>
		)
		:
		(
			<Placeholder className="casualevents-event" />
		)
	);
}

CasualEvents.propTypes = {
	id: PropTypes.string,
}

export default CasualEvents;